import type { ReactNode } from "react";

interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeading({ eyebrow, title, subtitle, action }: Props) {
  return (
    <div className="flex items-start justify-between gap-3 py-6">
      <div>
        {eyebrow ? <div className="label-eyebrow mb-2">{eyebrow}</div> : null}
        <h1 className="font-serif text-2xl sm:text-3xl text-ink leading-tight">{title}</h1>
        {subtitle ? <p className="mt-2 text-muted">{subtitle}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
